module.exports = __webpack_public_path__ + "static/img/memory_256.90da439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/memory_256.png
// module id = CCbG
// module chunks = 0